import React, {useContext, useEffect, useRef} from "react";
import {Animated, Linking, Platform, TouchableOpacity, View} from "react-native";
import {getTranslation} from "../helpers/getTranslation";
import PtCallout from "../components/core/pt-callout/pt-callout";
import UserContext from "../helpers/UserContext";
import {useSelector} from "react-redux";
import {SafeAreaView} from "react-native-safe-area-context";
import styles from "./screen-styles";
import PtHeader from "../components/pt-header/pt-header";
import {styleVars} from "../app-style-vars";
import Login from "../components/core/Login/login";
import Logout from "../components/core/logout/logout";
import PtText from "../components/core/pt-text/pt-text";
import getConfig from "../environment";
import PtCustomerInfo from "../components/pt-customer-info/pt-customer-info";
import {getSubdomain} from "../helpers/getSubdomain";

/** set this to styles.withBoundaries to display borders around container views to visually debug layout overflows */
const showBoundaries = null;

/** actual page content should be put inside ScreenTemplate tag,
 * each component/section wrapped in a
 * <View style={[styles.pageContentSlotContainer, showBoundaries]}> tag
 */

export default function WrongCountryScreen(props:any) {

  /** translations */
  const thisScreenTitle = getTranslation('access.denied.screen.title') || 'Access denied';
  const wrongCountryText = getTranslation('access.denied.error.message') || 'You are not authorized to access this storefront. Please validate the URL and try again.';

  const isAuthenticated: boolean = useSelector((state:any) => state.authReducer.isAuthenticated);
  const {userData, updateUserData} = useContext(UserContext)

  useEffect(() => {
    if(isAuthenticated !== userData.authenticated) {
      console.log('reset user data from wrong country screen after logout');
      // updateUserData({...userData, authenticated: isAuthenticated})
      updateUserData({
        ...userData,
        authenticated: false,
        dataCollected: false,
        country: getSubdomain(),
      })
    }
  },[isAuthenticated])


  /** fixing header on scroll */
  const headerFixedHeight = styleVars.headerFixedSectionHeight;
  const headerDiscardHeight = 0;
  const headerHeight = headerFixedHeight + headerDiscardHeight;
  const scrollY = new Animated.Value(0);
  const scrollYRef = useRef(scrollY);
  const handleScroll = Animated.event(
    [{
      nativeEvent: {
        contentOffset: {y: scrollYRef.current},
      },
    },],
    {
      useNativeDriver: true,
    },
  );
  const translateY = scrollYRef.current.interpolate({
    inputRange: [0, headerHeight, headerHeight + 1],
    outputRange: [0, -headerDiscardHeight, -headerDiscardHeight],
  });

  const headerOptions = {
    menuArea: null,
    headerTitle: thisScreenTitle,
    headerIcons: [],
    showLogo: false,
    nonavigation: true,
  };

  return (
    <SafeAreaView style={[styles.pageContainer, styles.pageContainerFullScreen, showBoundaries]}>
      <Animated.View style={[styles.fixedHeaderContainer, {transform:[{translateY}]}]}>
        <PtHeader headerOptions={headerOptions}/>
      </Animated.View>
      <Animated.ScrollView
        contentContainerStyle={{paddingBottom: Platform.OS !== 'web' ? headerHeight : 0, minHeight: '100%'}}
        style={[styles.pageScrollContainer, showBoundaries, {paddingTop: headerHeight},]}
        scrollEventThrottle={16}
        onScroll={handleScroll}
      >

        <View style={styles.inScrollContentContainer}>

          {!isAuthenticated ?
            <View>
              <PtCallout type={'error'} message={wrongCountryText}/>
              <PtText>Ovo je not authenticated varijanta</PtText>
              {/*<Login/>*/}
            </View>
            :
            <View>
              <PtCallout type={'error'} message={wrongCountryText}/>
              <Logout useButtonStyle={true}/>
            </View>
          }

        </View>

      </Animated.ScrollView>
    </SafeAreaView>
  )
}
